module.exports = __webpack_public_path__ + "static/media/Q2-Frequencyofsymptom.f4c3da60.svg";